import * as Yup from 'yup';

export const tipoValidationSchema = Yup.object().shape({
  id: Yup.number()
    .required('El ID es obligatorio')
    .typeError('El ID debe ser un número válido'),

  descripcion: Yup.string()
    .required('La descripción es obligatoria')
    .typeError('La descripción debe ser una cadena de texto válida'),
});

export const validateTipoForm = async (formData) => {
  try {
    await tipoValidationSchema.validate(formData, { abortEarly: false });
    return {};
  } catch (error) {
    const errors = {};
    if (error.inner) {
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
    }
    return errors;
  }
};